import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const fortuneColors = {
  primary50: '#F9F9FF',
  primary100: '#EEEFFB',
  primary200: '#CDCFF5',
  primary300: '#B5B8EE',
  primary400: '#9499E6',
  primary500: '#747ADF',
  primary600: '#545CD8',
  primary700: '#4248AF',
  primary800: '#40458B',
  primary900: '#2E3058',

  secondary50: '#F7FAFC',
  secondary100: '#EDF2F7',
  secondary200: '#E2E8F0',
  secondary300: '#CBD5E0',
  secondary400: '#A0AEC0',
  secondary500: '#718096',
  secondary600: '#637184',
  secondary700: '#525D6D',
  secondary800: '#424A57',
  secondary900: '#2F3640',
}

export const colorTheme = stylex.createTheme(colors, fortuneColors)
